import React from 'react';
import { useSelector } from 'react-redux';

import { ErrorContainer, ErrorMessageWrapper, ErrorHeader, ErrorText, ErrorList } from './response-error.styled';
import { getLabel } from '../../../../shared/form-lib';
import ErrorImage from './error-image';

const WasError = () => {
  const { oldForm, userCustomTexts } = useSelector((state) => state.form);

  return (
    <ErrorMessageWrapper>
      <ErrorContainer>
        <ErrorImage />
        <ErrorHeader>{getLabel('loading_error', userCustomTexts)}</ErrorHeader>
        {!oldForm && (
          <ErrorText>
            <p>We are sorry but there was an issue while loading this form. This could be because:</p>
            <ErrorList>
              <li>There was a connectivity error</li>
              <li>The form link isn’t accurate.</li>
              <li>The form has been deleted.</li>
              <li>The form doesn&apos;t exist.</li>
            </ErrorList>
            <p>
              Please check the link and reload the page. If the issue persists, please contact the form owner or
              <a href="https://help.formpl.us/s/contactsupport"> send us a support ticket</a>.
            </p>
          </ErrorText>
        )}
        {oldForm && (
          <p>
            This form was created with a previous version of Formplus. Please contact the owner for the updated form.
          </p>
        )}
      </ErrorContainer>
    </ErrorMessageWrapper>
  );
};

export default WasError;
